// The three card statuses the code relies on; each pipeline may name them itself
// (Pipeline#status_labels), e.g. "Realizada" for resolved.
export const CARD_STATUSES = ['open', 'resolved', 'canceled'];

// A status the pipeline leaves unnamed shows under its default name.
export const statusLabel = (labels, status, t) => {
  if (labels?.[status]) return labels[status];
  if (status === 'resolved') return t('CARDS.STATUS.resolved');
  if (status === 'canceled') return t('CARDS.STATUS.canceled');
  return t('CARDS.STATUS.open');
};

// A task's own statuses; each task type may name them (CardTaskType#status_labels), e.g.
// "Agendada" for a visit in progress.
export const TASK_STATUSES = ['pending', 'in_progress', 'done', 'canceled'];
export const OPEN_TASK_STATUSES = ['pending', 'in_progress'];

export const taskStatusLabel = (labels, status, t) => {
  if (labels?.[status]) return labels[status];
  if (status === 'in_progress') return t('CARDS.TASK_STATUS.in_progress');
  if (status === 'done') return t('CARDS.TASK_STATUS.done');
  if (status === 'canceled') return t('CARDS.TASK_STATUS.canceled');
  return t('CARDS.TASK_STATUS.pending');
};

// Where a task can go from each status, and the API transition that takes it there.
export const TASK_MOVES = {
  pending: { in_progress: 'start', done: 'complete', canceled: 'cancel' },
  in_progress: { done: 'complete', canceled: 'cancel' },
  done: { pending: 'reopen' },
  canceled: { pending: 'reopen' },
};

export const TASK_STATUS_STYLES = {
  // Waiting on the agency: the request is in and nobody has acted on it yet.
  pending: {
    icon: 'i-lucide-clock-alert',
    class: 'bg-n-slate-3 text-n-slate-11',
  },
  in_progress: {
    icon: 'i-lucide-circle-dot',
    class: 'bg-n-amber-3 text-n-amber-11',
  },
  done: {
    icon: 'i-lucide-circle-check-big',
    class: 'bg-n-teal-3 text-n-teal-11',
  },
  canceled: { icon: 'i-lucide-circle-x', class: 'bg-n-ruby-3 text-n-ruby-11' },
};
